// ThemeContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState('light');
    const [logoPosition, setLogoPosition] = useState({ top: 0, left: 0 });

    const toggleTheme = (position) => {
        setLogoPosition(position);
        setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light'); // Set theme state immediately
    };

    useEffect(() => {
        document.documentElement.className = theme;
        document.body.className = theme;
    }, [theme]);

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme, logoPosition }}>
            {children}
        </ThemeContext.Provider>
    );
};
